import React from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const formatDate = (string, defaultFormat = "DD-MM-YYYY") => {
  try {
    const obj = dayjs(string, "YYYY-MM-DD");
    return obj.format(defaultFormat);
  } catch (e) {
    return "-";
  }
};

const formatTime = (string) => {
  try {
    const obj = dayjs("2019-01-01 " + string);
    return obj.format("HH:mm");
  } catch (e) {
    return "-";
  }
};

const formatMoney = (string) => {
  let style = {};
  let value = parseFloat(string);
  if (value < 0) {
    style = { color: "red" };
  }
  return (
    <span style={style}>
      $ {Math.abs(value).toFixed(2)} {value > 0 ? "(A favor)" : ""}
    </span>
  );
};

const dayweekNumberToLabel = (day_of_week) => {
  switch (day_of_week) {
    case 0:
      return "Domingo";
    case 1:
      return "Lunes";
    case 2:
      return "Martes";
    case 3:
      return "Miercoles";
    case 4:
      return "Jueves";
    case 5:
      return "Viernes";
    default:
      return "Sábado";
  }
};

export const Formatters = {
  formatDate,
  formatTime,
  formatMoney,
  dayweekNumberToLabel,
};
